<template>

  <div v-if="editMode || filled">
    <div class="card-header">
      <i
        v-if="!editable && editMode"
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>{{ $t('Pages') }}</strong>
    </div>
    <div
      v-if="editable"
      class="card-body">
      
      <form v-on:submit.prevent="save(candidateEdit)">  
        <div 
          v-for="(item, index) in candidateEdit.pages"
          :key="index">
          <div class="input-group">
            <input class="form-control" type="text" v-model="candidateEdit.pages[index]" :placeholder="$t('URL')">
            <div class="input-group-prepend">
              <a href="javascript:void(0)" type="button" class="input-group-text" @click.stop="removeItem(index)">x</a>
            </div>
          </div>
          <ValidateMessage :error="validateErrors['pages.' + index]" />
        </div>

        <p><a href="javascript:void(0)" @click="addItem()">{{ $t('Add') }}</a></p>

        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary">
            {{ $t('Save') }}
            </button>
          <button
            type="button"
            class="btn btn-default"
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>
      </form>

    </div>
    <div
      class="p-3"
      v-if="!editable && filled">
      <div class="social-list">
        <a 
          v-for="(item, index) in candidate.pages"
          :key="index"
          :href="item"
          target="_blank"
          :style="{backgroundColor: getIconName(item).color}">
          <i :class="getIconName(item).class" />
        </a>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'CandidateProfilePages',
  components: {
  },
  props: [
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    resources () {
      return this.$store.getters.getResources
    },
    filled () {
      return this.candidate.pages && this.candidate.pages.length
    }
  },
  methods: {
    editSection (status) {
      this.sectionEdit = status
      this.candidateEdit = {
        _id: this.candidate._id,
        pages: Array.isArray(this.candidate.pages) ? this.candidate.pages : []
      }
    },
    save (data) {
      this.loading = true

      this.$store.dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    getIconName (url) {
      const domains = {
        'linkedin.com': {
          color: '#3c86ad',
          class: 'fab fa-linkedin-in'
        },
        'catho.com.br': {
          color: '#ff1478',
          class: 'fab fa-cuttlefish'
        },
        'twitter.com': {
          color: '#4fb7ec',
          class: 'fab fa-twitter'
        },
        'facebook.com': {
          color: '#5270a4',
          class: 'fab fa-facebook-f'
        },
        'instagram.com': {
          color: '#b14bb9',
          class: 'fab fa-instagram'
        },
        '--default--': {
          color: '#444444',
          class: 'fas fa-globe'
        }
      }

      const domain = Object.keys(domains).find(domain => url.includes(domain))
      return domains[domain || '--default--']
    },
    /*
    addItem
    */
    addItem () {
      this.candidateEdit.pages.push('')
    },
    /*
    removeItem
    */
    removeItem (index) {
      this.candidateEdit.pages.splice(index, 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.social-list{
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
}
  .social-list > *{
    margin: 2px;
    width: 2rem;
    height: 2rem;
    border-radius: 1rem;
    background: #000000;
    font-size: 1rem;
    line-height: 2rem;
    text-align: center;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfilePages.vue